import LazyLoad from 'vanilla-lazyload'


window.LazyLoad = LazyLoad

export class SearchDropdown {
  constructor () {
    this.lazyLoadVanilla()
  }

  init (config) {
    this._config = config || {}
  }

  lazyLoadVanilla () {
    return new LazyLoad({
      elements_selector: '.lazyload'
    })
  }
}
